var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_1836",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0664062,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 36.8164C8.2875 36.8164 7.46354 36.4737 6.77813 35.7883C6.09271 35.1029 5.75 34.2789 5.75 33.3164V8.81641C5.75 7.85391 6.09271 7.02995 6.77813 6.34453C7.46354 5.65911 8.2875 5.31641 9.25 5.31641H23.25V8.81641H9.25V33.3164H33.75V19.3164H37.25V33.3164C37.25 34.2789 36.9073 35.1029 36.2219 35.7883C35.5365 36.4737 34.7125 36.8164 33.75 36.8164H9.25ZM11 29.8164H32L25.4375 21.0664L20.1875 28.0664L16.25 22.8164L11 29.8164ZM30.25 15.8164V12.3164H26.75V8.81641H30.25V5.31641H33.75V8.81641H37.25V12.3164H33.75V15.8164H30.25Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.7dcdb605d0345600e44d1f7f022dbda0.svg";
export { ForwardRef as ReactComponent };